import { SkeletonBlock } from '@/components/common/skeleton';

import styles from './support-ticket-detail-skeleton.module.scss';

/** Side + bubble width for each placeholder message, mirroring the alternating chat thread. */
const BUBBLES: { mine: boolean; width: string }[] = [
  { mine: false, width: '58%' },
  { mine: true, width: '42%' },
  { mine: false, width: '70%' },
  { mine: true, width: '50%' },
  { mine: false, width: '36%' },
];

/**
 * Loading placeholder for the Ticket Detail chat drawer — a dark-green header block, a stack
 * of alternating message-bubble placeholders, and a composer bar — so the swap to the real
 * {@link DetailBody} doesn't reflow.
 */
export function SupportTicketDetailSkeleton() {
  return (
    <div className={styles.body} aria-busy="true" aria-label="Loading ticket">
      <header className={styles.header}>
        <span className={styles.headerLeft}>
          <SkeletonBlock height={20} width="60%" className={styles.onDark} />
          <SkeletonBlock height={13} width="40%" className={styles.onDark} />
        </span>
        <SkeletonBlock height={22} width={64} radius={999} className={styles.onDark} />
      </header>

      <div className={styles.thread}>
        {BUBBLES.map((b, i) => (
          <div key={i} className={`${styles.bubbleRow} ${b.mine ? styles.bubbleMine : ''}`}>
            <SkeletonBlock height={56} width={b.width} radius={22} className={styles.bubble} />
          </div>
        ))}
      </div>

      <div className={styles.composer}>
        <SkeletonBlock height={44} radius={999} className={styles.composerInput} />
        <SkeletonBlock height={44} width={44} circle />
      </div>
    </div>
  );
}
